module.exports = __webpack_public_path__ + "static/media/manual_inventario_faisas.7ce7eda4.pdf";